import React from 'react';

import { Widget } from 'app/design-system/components/Widget/Widget';
import { useTranslation } from 'app/lang';
import PromocodeForm from 'app/widgets/PromocodeForm';

import dictionary from './PromoWidget.dictionary.json';

export const PromoWidget = () => {
  const { t } = useTranslation();

  return (
    <Widget title={t(dictionary.title)}>
      <PromocodeForm />
    </Widget>
  );
};
